import React from 'react';
import { X } from 'lucide-react';
import { Button } from './button';

interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: 'danger' | 'warning' | 'info';
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirmer',
  cancelText = 'Annuler',
  variant = 'danger'
}) => {
  if (!isOpen) return null;

  const getVariantStyles = () => {
    switch (variant) {
      case 'danger':
        return {
          button: 'bg-red-500 hover:bg-red-600 text-white',
          icon: 'text-red-500'
        };
      case 'warning':
        return {
          button: 'bg-amber-500 hover:bg-amber-600 text-white',
          icon: 'text-amber-500'
        };
      case 'info':
        return {
          button: 'bg-primary hover:bg-primary/90 text-white',
          icon: 'text-primary'
        };
      default:
        return {
          button: 'bg-red-500 hover:bg-red-600 text-white',
          icon: 'text-red-500'
        };
    }
  };

  const styles = getVariantStyles();

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-900 rounded-lg shadow-xl max-w-md w-full">
        <div className="p-6">
          <div className="flex justify-between items-start mb-4">
            <h3 className="text-xl font-semibold">{title}</h3>
            <button 
              type="button"
              onClick={onClose}
              className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800"
            >
              <X size={20} className="text-gray-500" />
            </button>
          </div>
          
          <div className="mb-6">
            <p className="text-gray-700 dark:text-gray-300">{message}</p>
          </div>
          
          <div className="flex justify-end space-x-2">
            <Button 
              type="button"
              onClick={onClose}
              variant="outline"
            >
              {cancelText}
            </Button>
            <Button 
              type="button"
              onClick={() => {
                onConfirm();
                onClose();
              }}
              className={styles.button}
            >
              {confirmText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
